export default () => {
    $('.checkbox-input').off('click').click(function (e) {
        $(this).toggleClass('checked');
        $(this).parent().toggleClass('checked');
    });
}
